module.exports = __webpack_public_path__ + "static/media/training_4_mind_body_fitness.115cdf36.webp";